import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
} from "chart.js"
import { Line } from "react-chartjs-2"

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

interface CompanyAccess {
  companyId: string
  companyName: string
  totalAccess: Record<string, number>
}

interface Props {
  data: CompanyAccess[]
}

const generateColor = (index: number, total: number): string => {
  const hue = (index / total) * 360
  return `hsl(${hue}, 70%, 55%)`
}

export const LineChart = ({ data }: Props) => {
  const months = data.length > 0 ? Object.keys(data[0].totalAccess).sort() : []

  const datasets = data.map((company, idx) => {
    const color = data.length === 1 ? "#FF5E1E" : generateColor(idx, data.length)
    return {
      label: company.companyName,
      data: Object.values(company.totalAccess),
      borderColor: color,
      backgroundColor: color,
      pointBackgroundColor: color,
      pointBorderColor: "#fff",
      tension: 0.4,
      fill: false,
    }
  })

  const chartData = {
    labels: months,
    datasets
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 1500,
      easing: "easeInOutQuart",
      onProgress: (animation: any) => {
        const chart = animation.chart
        const ctx = chart.ctx
        ctx.save()
        ctx.globalCompositeOperation = "destination-over"
        ctx.restore()
      },
    },
    plugins: {
      tooltip: {
        mode: "index" as const,
        intersect: false,
      },
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    interaction: {
      mode: "nearest" as const,
      intersect: false,
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
      },
      y: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          stepSize: 1,
          precision: 0,
        },
      },
    },
  } as unknown as ChartOptions<"line">

  return (
    <Line data={chartData} options={options} />
  )
}
